import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import { addStore, fetchStores } from '../../../../redux/storesSlice';
import { fetchUserBusinesses } from '../../../../redux/userBusinessesSlice';
import { notifyError, notifySuccess } from '../../../Notification';
import './accessStoreControl.css';

const DraggableMarker = ({ position, setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition([e.latlng.lat, e.latlng.lng]);
    },
  });

  return (
    <Marker
      draggable
      position={position}
      eventHandlers={{
        dragend: (e) => {
          const marker = e.target;
          const newPos = marker.getLatLng();
          setPosition([newPos.lat, newPos.lng]);
        },
      }}
    />
  );
};

const AddStoreModal = ({ onClose }) => {
  const [storeName, setStoreName] = useState('');
  const [googleReviewUrl, setGoogleReviewUrl] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [markerPosition, setMarkerPosition] = useState([-34.927948, 138.599923]); // Default: Delhi

  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.stores);
  const businessId = localStorage.getItem('selectedBusinessId');

  useEffect(() => {
    setLatitude(markerPosition[0]);
    setLongitude(markerPosition[1]);
  }, [markerPosition]);

  const handleSubmit = () => {
    if (!storeName) {
      notifyError('Please fill in the site name.');
      return;
    }

    dispatch(addStore({
      name: storeName,
      latitude,
      longitude,
      google_review_url: googleReviewUrl,
      business_id: businessId,
    }))
      .unwrap()
      .then(() => {
        notifySuccess(`Store "${storeName}" added successfully`);
        dispatch(fetchStores(businessId));
        // fetch user businesses from backend
         dispatch(fetchUserBusinesses(localStorage.getItem("user")));
       
        onClose();
      })
      .catch((err) => {
        notifyError(err || 'Failed to add store');
      });
  };

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    if (error) {
      notifyError(error);
    }
  }, [error]);

  // Update marker position if lat/lng manually change
  useEffect(() => {
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);
    if (!isNaN(lat) && !isNaN(lng)) {
      setMarkerPosition([lat, lng]);
    }
  }, [latitude, longitude]);

  return (
    <div>
      {loading && <div className='loading'>Loading...</div>}
      <div className="add-store-form-wrapper">
  {/* Row 1: Store Name & Google Review URL */}
  <div className="input-row">
    <div className="add-store-input-group">
      <div className="slide1-section-title">Enter New Site Name:</div>
      <input
        className="add-business-input"
        type="text"
        value={storeName}
        onChange={(e) => setStoreName(e.target.value)}
      />
    </div>

    <div className="add-store-input-group">
      <div className="slide1-section-title">Google Review URL:</div>
      <input
        className="add-business-input"
        type="text"
        value={googleReviewUrl}
        onChange={(e) => setGoogleReviewUrl(e.target.value)}
      />
    </div>
  </div>

  {/* Row 2: Latitude & Longitude */}
  <div className="input-row">
    <div className="add-store-input-group">
      <div className="slide1-section-title">Latitude:</div>
      <input
        className="add-business-input"
        type="text"
        value={latitude}
        onChange={(e) => setLatitude(e.target.value)}
      />
    </div>

    <div className="add-store-input-group">
      <div className="slide1-section-title">Longitude:</div>
      <input
        className="add-business-input"
        type="text"
        value={longitude}
        onChange={(e) => setLongitude(e.target.value)}
      />
    </div>
  </div>

  {/* Map */}
  
  <MapContainer
    center={markerPosition}
    zoom={13}
    scrollWheelZoom={true}
    style={{ height: '300px', width: '100%', marginBottom: '1em' }}
  >
    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
    <DraggableMarker position={markerPosition} setPosition={setMarkerPosition} />
  </MapContainer>

  <div className="add-business-btns-container">
    <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
  </div>
</div>

    </div>
  );
};

export default AddStoreModal;
